import { Box, Button, Grid, Paper, Typography } from "@mui/material"
import { Link, useParams } from "react-router-dom"
import { usePublicDb } from "@in-and-out-belleza/api/resources"
import { BeautyIcon } from "@in-and-out-belleza/ui"
import { useNav } from "../../hooks/useNav"
import { getCartTotal } from "@in-and-out-belleza/api/utils"
import { BuyButton } from "../Buttons/BuyButton"

const FamilyProducts = () => {
  const { db } = usePublicDb()
  const { menuHref } = useParams()
  const { products } = useNav()
  const prds = db.products
    .filter(item => item.menuHref === menuHref)
    .map(item => {
      const price = getCartTotal(db, [item.id])
      const discount = price.real - price.total
      return { ...item, discount }
    })
    .sort((first, second) => {
      if (first.discount - second.discount === 0) {
        return first.title.localeCompare(second.title)
      }
      return first.discount - second.discount
    })

  return (
    <Box component="div">
      <Paper component={Link} to={products.url()} sx={{ m: 1, p: 1, display: "flex" }}>
        <Typography>VOLVER A TODOS LOS PRODUCTOS</Typography>
        <Box component="div" sx={{ flexGrow: 1, justifyContent: "end", display: "flex" }}>
          <BeautyIcon name="products" size={20} />
        </Box>
      </Paper>
      <Grid container spacing={0.2}>
        {prds.map(item => (
          <Grid item xs={12} sm={6} key={item.id}>
            <Paper sx={{ m: 1, position: "relative", display: "block", height: "98%" }}>
              <Box component="div" sx={{ p: 1 }}>
                <img width="100px" src={item.photo} alt={item.title} style={{ float: "left" }} />
                <Typography variant="h6">{item.title}</Typography>
                <Typography sx={{ color: "#999" }}>{item.quantity}</Typography>
                <Box component="div" sx={{ display: "flex", clear: "both" }}>
                  <Button component={Link} to={item.href}>
                    VER DETALLES
                  </Button>
                  <Box component="div" sx={{ flexGrow: 1, justifyContent: "end", display: "flex" }}>
                    <BuyButton cart={[item.id]} variant="contained" sx={{ margin: 0.5 }} />
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export { FamilyProducts }
